<script>
  export default {
    data() {
      return {
        auth_user: authUser
      }
    },
    methods: {
      $can(permissionName) {
        return Permissions.indexOf(permissionName) !== -1;
      },
    },
  };
</script>